import { FeatureSwitch } from './featureSwitches'

type TextSuggestionsExperimentStateParams = {
  isTextSuggestionsFlowOptionEnabled: boolean
  isTextSuggestionsFeatureLoadedFromBackend: boolean
  textSuggestionsFeatureValue: boolean | undefined
  textSuggestionsFeature?: FeatureSwitch
}

type TextSuggestionsExperimentState = {
  isInExperiment: boolean
  isTextSuggestionsEnabled: boolean
}

export function getTextSuggestionsExperimentState({
  isTextSuggestionsFlowOptionEnabled,
  isTextSuggestionsFeatureLoadedFromBackend,
  textSuggestionsFeatureValue,
  textSuggestionsFeature,
}: TextSuggestionsExperimentStateParams): TextSuggestionsExperimentState {
  if (!isTextSuggestionsFlowOptionEnabled) {
    return {
      isInExperiment: false,
      isTextSuggestionsEnabled: false,
    }
  }

  if (!textSuggestionsFeature) {
    return {
      isInExperiment: false,
      isTextSuggestionsEnabled: true,
    }
  }

  const isInExperiment = isTextSuggestionsFeatureLoadedFromBackend && textSuggestionsFeatureValue !== undefined

  if (!isInExperiment) {
    return {
      isInExperiment: false,
      isTextSuggestionsEnabled: false,
    }
  }

  return {
    isInExperiment: true,
    isTextSuggestionsEnabled: textSuggestionsFeatureValue === true,
  }
}
